module.exports = "/assets/restaurant-photo@3x.png?FfRIP5J";